import { AxiosPromise } from 'axios';

import { api } from './api';

export type GetProductsParams = {
  search: string | null;
  brands: string | null;
  ranges: string | null;
};

type ParamsKeys = 'search' | 'brands' | 'ranges';

export const defaultParams = {
  search: null,
  brands: null,
  ranges: null,
};

// 22/08/2022: The server cannot disable pagination for some endpoints whish its limited to 30 items
const itemsPerPage = 10000;

export class ProductAPI {
  static getChallengeProductsBrands(challengeId?: string): AxiosPromise {
    return api.get('/challenge-products/brands', {
      params: challengeId ? { challenge: challengeId } : undefined,
    });
  }

  static getChallengeProductsRanges(challengeId?: string): AxiosPromise {
    return api.get('/challenge-products/ranges', {
      params: challengeId ? { challenge: challengeId } : undefined,
    });
  }

  static getChallengeProducts(
    params: GetProductsParams = defaultParams,
    id: number,
  ): AxiosPromise {
    const paramsKeys = Object.keys(params) as ParamsKeys[];
    const formattedParams = paramsKeys.reduce((acc, curr) => {
      if (!params[curr]) {
        return acc;
      }
      return {
        ...acc,
        [curr]: params[curr],
      };
    }, {});

    return api.get('/challenge-list-products.jsonld', {
      params: {
        itemsPerPage,
        ...formattedParams,
        id,
      },
    });
  }
}
